import { Mail, Phone, MapPin, Facebook, Linkedin, Twitter } from 'lucide-react'
import { STORE_NAME, COMPANY } from '../config'

export function Footer({ onNavigate }) {
  const links = [
    { label: 'Home', view: 'home' },
    { label: 'Catalog', view: 'catalog' },
    { label: 'About', view: 'about' },
    { label: 'Who we are', view: 'who-we-are' },
    { label: 'Contact', view: 'contact' }
  ]

  return (
    <footer className="bg-brand-navy px-4 py-14 text-white sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <h3 className="font-display text-2xl font-bold text-brand-gold-light">{STORE_NAME}</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/70">
              At {STORE_NAME}, we connect global producers with retail and wholesale buyers through
              transparent pricing, verified quality and reliable logistics — from our base in Bree, Belgium.
            </p>
            <div className="mt-4 flex gap-4">
              {[Facebook, Linkedin, Twitter].map((Icon, i) => (
                <a key={i} href="#" className="rounded-full bg-white/10 p-2 text-white/80 hover:bg-brand-gold hover:text-brand-navy">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-brand-gold">Explore</h4>
            <ul className="space-y-2">
              {links.map((l) => (
                <li key={l.view}>
                  <button
                    onClick={() => onNavigate(l.view)}
                    className="text-sm text-white/70 transition hover:text-brand-gold"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-brand-gold">Contact</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-brand-gold" /> {COMPANY.address}</li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-brand-gold" /> {COMPANY.phone}</li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-brand-gold" /> {COMPANY.email}</li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-brand-gold">Newsletter</h4>
            <p className="text-sm text-white/70">Get weekly market updates and new arrivals.</p>
            <form onSubmit={(e) => e.preventDefault()} className="mt-3 flex gap-2">
              <input
                type="email"
                placeholder="Email address"
                className="w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none placeholder:text-white/40 focus:border-brand-gold"
              />
              <button className="rounded-lg bg-brand-gold px-4 py-2 text-sm font-bold text-brand-navy hover:bg-brand-gold-light">
                Join
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-white/50">
          © {new Date().getFullYear()} {COMPANY.legalName} — KBO {COMPANY.kbo} — VAT {COMPANY.vat}
        </div>
      </div>
    </footer>
  )
}
